// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__16cxk","fullscreen":"styles_fullscreen__P9Gcw","icon":"styles_icon__2Fs38"};